import React from "react";
import "./LimitedEditionCardBorder.css";

type LimitedEditionCardBorderProps = {
  children: React.ReactNode;
};

export default function LimitedEditionCardBorder({ children }: LimitedEditionCardBorderProps) {
  return (
    <div className="limited-edition-card-border">
      <div className="limited-edition-card-border__metal-outer">
        <div className="limited-edition-card-border__black">
          <div className="limited-edition-card-border__metal-inner">
            <div className="limited-edition-card-border__inner">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
